import { render, staticRenderFns } from "./ReChannels.vue?vue&type=template&id=7725c42d&scoped=true"
import script from "./ReChannels.vue?vue&type=script&lang=js"
export * from "./ReChannels.vue?vue&type=script&lang=js"
import style0 from "./ReChannels.vue?vue&type=style&index=0&id=7725c42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7725c42d",
  null
  
)

export default component.exports